export enum TokenTypes {
  ID_TOKEN = "@HUNGER/MERCHANT/ID_TOKEN",
  ACCESS_TOKEN = "@HUNGER/MERCHANT/ACCESS_TOKEN",
  VALIDATE_TOKEN = "@HUNGER/MERCHANT/VALIDATE_TOKEN",
}
